const t = "Naciśnij Enter, aby edytować", e = {
  pressEnterToEdit: t
};
export {
  e as default,
  t as pressEnterToEdit
};
